import { ApiService } from '@/services/api.service';

export default {
  state: {},
  getters: {},
  actions: {
    getDomains: () =>
      new Promise((resolve, reject) => {
        ApiService.get('/domains')
          .then(({ data }) => {
            resolve(data.domains);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getDomainEntities: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/domains/${domain}/entities`)
          .then(({ data }) => {
            resolve(data.results);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    setNotes: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/forms/setNotes', params)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      }),
    getFieldForms: (
      store,
      {
        domain,
        bcFilter,
        salesDistrictFilter,
        serviceDistrictFilter,
        layoutFilter,
        periodFilter,
        statusFilter,
        page,
        search,
      },
    ) =>
      new Promise((resolve, reject) => {
        ApiService.get(
          `/forms/${domain}?bcFilter=${bcFilter}&salesDistrictFilter=${salesDistrictFilter}&serviceDistrictFilter=${serviceDistrictFilter}&layoutFilter=${layoutFilter}&periodFilter=${periodFilter}&overallStatus=${statusFilter}&pageNumber=${page}&search=${search}`,
          {},
        )
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getFieldFormById: (store, { domain, formIdFilter }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/${domain}?formIdFilter=${formIdFilter}`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getForm: (store, { formId }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/single/${formId}`, {})
          .then(({ data }) => {
            resolve(data.form);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getFieldFilters: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/${domain}/filters`)
          .then(({ data }) => {
            resolve(data.filters);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getUserLookup: (
      store,
      { domainFilter, roleFilter, serviceDistrictFilter, salesDistrictFilter, bcFilter, page, search },
    ) =>
      new Promise((resolve, reject) => {
        ApiService.get(
          `/roles/lookup/?domainFilter=${domainFilter}&roleFilter=${roleFilter}&serviceDistrictFilter=${serviceDistrictFilter}&salesDistrictFilter=${salesDistrictFilter}&bcFilter=${bcFilter}&pageNumber=${page}&search=${search}`,
          {},
        )
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getDistrictFilters: () =>
      new Promise((resolve, reject) => {
        ApiService.get('/forms/districtfilters')
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getRequests: (store, { domain, typeFilter, statusFilter, actionFilter, search, page }) =>
      new Promise((resolve, reject) => {
        ApiService.get(
          `/securitycenter/${domain}?type=${typeFilter}&status=${statusFilter}&action=${actionFilter}&searchFilter=${search}&pageNumber=${page}`,
          {},
        )
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getRequestReviews: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/securitycenter/requests/${domain}`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getMultipleDomains: (store, { roleType }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/securitycenter/multiple/domains?roleType=${roleType}`)
          .then(({ data }) => {
            resolve(data.curUserAccessibleDomains);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getDistrictLists: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/domains/districts/${domain}`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getBcLevels: (store, { domains }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/securitycenter/multiple/bcs/?domains=${domains}`, {})
          .then(({ data }) => {
            resolve(data.curUserAccessibleBC);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    validateEntity: (store, { domains, roletype, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/securitycenter/entity/validate/${roletype}/${entity}?domains=${domains}`, {})
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getRolesByDomain: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/roles/types/${domain}`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getRolesByDomainAndType: (store, { roleType, userId, domains, entity, bcs }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/roles/${roleType}/${userId}/?domains=${domains}&entity=${entity}&bc=${bcs}`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    changeRoleOptions: (store, { domains, userId, roleType, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/securitycenter/dropdown/${userId}/${roleType}/?domains=${domains}&entity=${entity}`, {})
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    addRequest: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/securitycenter/save', params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getUserByIdField: (store, { domain, userId, firstName, lastName, email, roleType, entity }) =>
      new Promise((resolve, reject) => {
        ApiService.get(
          `/users/${domain}?userId=${userId}&firstName=${firstName}&lastName=${lastName}&email=${email}&roleType=${roleType}&entity=${entity}`,
          {},
        )
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getSingleRequest: (store, { id }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/securitycenter/single/${id}`, {})
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    cancelRoleRequest: (store, { id }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/securitycenter/cancel/${id}`, {})
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    editRequest: (store, { requestId, params }) =>
      new Promise((resolve, reject) => {
        ApiService.post(`/securitycenter/${requestId}`, params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    reviewRequest: (store, { id, params }) =>
      new Promise((resolve, reject) => {
        ApiService.post(`/securitycenter/review/${id}`, params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getRoleTypeFilterOptionsField: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/securitycenter/filter/roletypes/${domain}`, {})
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    updateForm: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/forms/updateStatus', params)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    editForm: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/forms/editForm', params)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getComments: (store, { formId }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/${formId}/comments`, {})
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getSubmissionForms: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/submissionForms/${domain}`)
          .then(({ data }) => {
            resolve(data.formIds);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getConfigsForFinalization: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/${domain}/config/active`)
          .then(({ data }) => {
            resolve(data.configs);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    finalizeAppeals: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/forms/finalize', params)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            if (error.response.status === 403) {
              resolve('invalid_permissions');
            }
            reject(error.response);
          });
      }),
    getConfigsForExecReport: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/${domain}/config/active`)
          .then(({ data }) => {
            resolve(data.configs);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getExecReport: (store, { configId, domain }) =>
      new Promise((resolve, reject) => {
        ApiService.post(`/forms/execReport/${configId}/${domain}`, {})
          .then(({ data }) => {
            resolve(data.url);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    resetForm: (store, { formId }) =>
      new Promise((resolve, reject) => {
        ApiService.put(`/forms/reset/${formId}`, {})
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getSIEntities: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/survey-interference/subsystems/entities/${domain}`)
          .then(({ data }) => {
            resolve(data.siSubEntities);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getHqAppealsData: (store, { entity, period, letterType, letterDate, market, page }) =>
      new Promise((resolve, reject) => {
        ApiService.get(
          `/survey-interference/subsystems/hq/review/${entity}/${period}/${letterType}/${letterDate}/${market}/?page=${page}`,
        )
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    submitHqReview: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/survey-interference/subsystems/hq/review ', params)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
  },
};
